import { Component } from '@theme/component';

export class CsTestimonials extends Component {
  constructor() {
    super();
    this.currentIndex = 0;
    this.autoplayTimer = null;
  }

  connectedCallback() {
    this.prevBtn = this.querySelector('.cs-testimonials__nav-btn--prev');
    this.nextBtn = this.querySelector('.cs-testimonials__nav-btn--next');

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.showPrev());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.showNext());
    }

    this.addEventListener('click', (event) => {
      const mediaBtn = event.target.closest('.cs-testimonials__media-item');
      if (!mediaBtn || !this.contains(mediaBtn)) return;

      const indexAttr = mediaBtn.getAttribute('data-testimonial-index');
      const index = parseInt(indexAttr, 10);
      if (!Number.isNaN(index)) this.goTo(index);

      const videoUrl = mediaBtn.getAttribute('data-video-url');
      if (videoUrl) this.openVideoModal(videoUrl);
    });

    this.setupAutoplay();
  }

  disconnectedCallback() {
    this.clearAutoplay();
  }

  getSlide(index) {
    return this.querySelector(`.cs-testimonials__slide[data-testimonial-index="${index}"]`);
  }

  getMedia(index) {
    return this.querySelector(`.cs-testimonials__media-item[data-testimonial-index="${index}"]`);
  }

  get activeIndex() {
    const active = this.querySelector('.cs-testimonials__slide.is-active');
    if (!active) return 0;
    const idx = parseInt(active.getAttribute('data-testimonial-index'), 10);
    return Number.isNaN(idx) ? 0 : idx;
  }

  get maxIndex() {
    let i = 0;
    while (this.getSlide(i)) i += 1;
    return i - 1;
  }

  goTo(index) {
    if (this.maxIndex < 0) return;

    if (index < 0) index = this.maxIndex;
    if (index > this.maxIndex) index = 0;

    const prev = this.activeIndex;

    const prevSlide = this.getSlide(prev);
    const prevMedia = this.getMedia(prev);
    const nextSlide = this.getSlide(index);
    const nextMedia = this.getMedia(index);

    if (prevSlide) prevSlide.classList.remove('is-active');
    if (prevMedia) prevMedia.classList.remove('is-active');
    if (nextSlide) nextSlide.classList.add('is-active');
    if (nextMedia) nextMedia.classList.add('is-active');

    this.currentIndex = index;
    this.restartAutoplay();
  }

  showPrev() {
    this.goTo(this.activeIndex - 1);
  }

  showNext() {
    this.goTo(this.activeIndex + 1);
  }

  setupAutoplay() {
    const autoplayAttr = this.getAttribute('data-autoplay');
    const shouldAutoplay = autoplayAttr === 'true' || autoplayAttr === '1';

    if (!shouldAutoplay) return;

    const intervalAttr = this.getAttribute('data-interval');
    const interval = parseInt(intervalAttr || '8000', 10);

    this.autoplayTimer = window.setInterval(
      () => this.showNext(),
      Number.isNaN(interval) ? 8000 : interval
    );
  }

  clearAutoplay() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    this.clearAutoplay();
    this.setupAutoplay();
  }

  openVideoModal(url) {
    const modal = document.getElementById('cs-video-modal');
    const player = document.getElementById('cs-video-player');

    if (!modal || !player) {
      console.warn('Video modal not found in DOM.');
      return;
    }

    player.src = url;
    modal.hidden = false;

    const closeBtn = modal.querySelector('.cs-video-modal__close');
    const backdrop = modal.querySelector('.cs-video-modal__backdrop');

    if (closeBtn) closeBtn.onclick = () => this.closeVideoModal();
    if (backdrop) backdrop.onclick = () => this.closeVideoModal();
  }

  closeVideoModal() {
    const modal = document.getElementById('cs-video-modal');
    const player = document.getElementById('cs-video-player');

    if (!modal || !player) return;

    player.pause();
    player.src = '';
    modal.hidden = true;
  }
}

if (!customElements.get('cs-testimonials')) {
  customElements.define('cs-testimonials', CsTestimonials);
}
